import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { HandleError } from './hanledError';
import 'rxjs/add/operator/do';
import { tap, catchError, finalize } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
//import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

    constructor(
        private _LocalStorageService: LocalStorageService,
        private _HandleError: HandleError,
        private spinnerService: NgxSpinnerService

    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        this.spinnerService.show();
        let token: string = this._LocalStorageService.get('tokenUserActive')

        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        // request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        // request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });

        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
            }),
            catchError((err: any) => {
                this.spinnerService.hide();
                return err;
            }),
			finalize(() => {
				this.spinnerService.hide();
			})

        );
    }
}
